export function getCustomPresignedPost({ presignedPost, binaryFile }) {

    const rs = { ...presignedPost }
    const ext = presignedPost.fields.key.split('.').pop()
    const contentType = binaryFile.type || 'application/octet-stream'

    rs.ext = ext
    rs.contentType = contentType
    rs.formData = new FormData()
    rs.formData.append("Content-Type", contentType)
    Object.entries(presignedPost.fields).forEach(([key, value]) => {
        rs.formData.append(key, value)
    })
    rs.formData.append('file', binaryFile)

    rs.headers = {
        'Content-Type': contentType
    }

    return rs

}

export function addRequestTag(value) {

    const request = '{request}'
    const confirm = '{confirm}'

    value = value.replaceAll(request, '')
    value = value.replaceAll(confirm, '')
    value = request + value

    return value

}

export function addConfirmTag(value) {

    const request = '{request}'
    const confirm = '{confirm}'

    value = value.replaceAll(request, '')
    value = value.replaceAll(confirm, '')
    value = confirm + value

    return value

}